export const REQUIRED = (v: string) => !!v || 'Field is required';
export const RATING_REQUIRED = (v: number) => !!v && v >= 0 || 'Rating is required';
export const WEIGHT_RANGE = (v: number) => v >= -1 && v <= 1 || 'Value must be within range of -1 and 1';
export const SCORE_RANGE = (v: number) => v >= 0 && v <= 100 || 'Value must be within range of 0 and 100';

const PASSWORD_STRENGTH_REGEX: RegExp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])((?=.*[0-9])|(?=.*[!@#\$%\^&\*]))(?=.{8,})");
export const PASSWORD_STRENGTH = (v: string) => PASSWORD_STRENGTH_REGEX.test(v) || 'Use 8 or more characters with a mix of letters, numbers & symbols';

const EMAIL_REGEX: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const EMAIL_FORMAT = (v: string) => EMAIL_REGEX.test(v) || 'Not a valid email';

export const PHONE_FORMAT = (v: string) => ((v || '').length == 0 || (v || '').length == 14) || 'Must be 10 digits'; // minus 4 digits for the v-mask used